enum EPromotionType {
  DISCOUNT = 'discount',
  PROMO_CODES = 'promo_codes',
  TEXT_PROMOTION = 'text_promotion',
  KIT = 'kit',
}

export default EPromotionType;
